import { data } from "@escapio/shared/state/payload";

let promise = null;
export const loadMapLibre = async () => {
	if (!promise) {
		promise = new Promise(resolve => {
			const style = document.createElement("link");
			style.setAttribute("rel", "stylesheet");
			style.setAttribute("href", data.maplibre_css_url);
			document.head.appendChild(style);

			import(data.maplibre_bundle_url).then(module => resolve(module.default));
		});
	}
	return promise;
};
